import { useCallback, useMemo, useState } from 'react'

export function deepEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true
  if (typeof a !== typeof b || a === null || b === null) return false
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((item, index) => deepEqual(item, b[index]))
  }
  if (typeof a === 'object' && typeof b === 'object') {
    const aObj = a as Record<string, unknown>
    const bObj = b as Record<string, unknown>
    const keysA = Object.keys(aObj)
    if (keysA.length !== Object.keys(bObj).length) return false
    return keysA.every((key) => deepEqual(aObj[key], bObj[key]))
  }
  return false
}

export function useDraftApplied<T>(initial: T) {
  const [draft, setDraft] = useState(initial)
  const [applied, setApplied] = useState(initial)
  const isDirty = useMemo(() => !deepEqual(draft, applied), [draft, applied])
  const patchDraft = useCallback((partial: Partial<T>) => {
    setDraft((prev) => ({ ...prev, ...partial }))
  }, [])
  const apply = useCallback(() => {
    setApplied(draft)
  }, [draft])
  const resetTo = useCallback((next: T) => {
    setDraft(next)
    setApplied(next)
  }, [])
  return { draft, setDraft, applied, setApplied, patchDraft, apply, resetTo, isDirty }
}
